import React from "react";

import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { BaseBean } from "../ds/client_ds.js";
import {
  CustomerSearchCriteria,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  RestCustomerListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventoryBean,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { ModuleUtils } from "./ModuleUtils.js";
class SkuInventoryAllocation extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Sku Inventory Allocation",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      isShowExitButton: true,
      error_list: [],
      inquiryDataList: [],
      criteria: new SKUBatchInventorySearchCriteria(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      alertMessage: [],
      alertType: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      colorLookupHandler: null,
      isShowColorLookup: false,
      colorList: new Array(),
      isShowRollSkuPopup: false,
      isShowLookup: true,
      isDisabledFields: false,
      fabricLookupHandler: null,
      customerLookupHandler: null,
      fabricColourPageListForAutoCompleteList: new Array(),
      fabricPageListForAutoCompleteList: new Array(),
      showAutoCompleteFabricList: true,
      showAutoCompleteFabricColorList: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      skuBatchInventoryBean: new SKUBatchInventoryBean(),
      showAutoCompleteCustomerList: true,
      customerPageListForAutoCompleteList: new Array(),
      order: "asc",
      sortField: "",
      is3PL: false,
      // isViewMode: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();
    ModuleUtils.getPurchaseOrderStatusList();
  }
  initLookupHandlers = () => {
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisabledFields: true,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onRollChange = (e) => {
    let criteria = this.state.skuBatchInventoryBean;
    criteria[e.target.name] = e.target.value;
    this.setState({ skuBatchInventoryBean: criteria });
  };
  customerEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading Customer ...",
    });
    this.readandsetCustomerCodeDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  customerOnChange = (e) => {
    let reserveCustomerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.skuBatchInventoryBean;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(reserveCustomerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.skuBatchInventoryBean;
      criteria.reserveCustomerCode = "";
      criteria.reserveCustomerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        skuBatchInventoryBean: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "reserveCustomerCode" &&
      showAutoCompleteList === true &&
      reserveCustomerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ skuBatchInventoryBean: tempCriteria });
  };
  readandsetCustomerCodeDetailResponse = (response) => {
    let criteria = this.state.skuBatchInventoryBean;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.reserveCustomerName = customerData.description;
        criteria.reserveCustomerCode = customerData.code;
        this.setState({
          skuBatchInventoryBean: criteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  readandsetCustomerCodeDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerCodeDetailResponse,
      this.errorCallBack
    );
  };
  customerCodeOnChange = (e) => {
    let reserveCustomerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(reserveCustomerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.reserveCustomerCode = "";
      criteria.reserveCustomerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "reserveCustomerCode" &&
      showAutoCompleteList === true &&
      reserveCustomerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.reserveCustomerName = customerData.description;
        criteria.reserveCustomerCode = customerData.code;
        this.setState({
          criteria: criteria,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading Customer ...",
    });
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.readandsetFabricStyleDetail(fabricStyleCode);
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.colorCode == searchString
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let colorCode = e.target.value;
    this.fabricStyleColorSelected(colorCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    if (!isEmpty(fabricStyle)) {
      fabricStyle.fabricStyleSkus.map((sku) => {
        if (
          sku.fabricStyleCode == criteria.fabricStyleCode &&
          sku.colorCode == colorCode
        )
          skuBean = sku;
      });
    }
    criteria.colorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  loadPage = (pageNumber) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing ...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = pageNumber;
    let listRequest = new RestSkuBatchInventoryListRequest();
    listRequest.searchCriteria = criteria;
    listRequest.pageInput = pageInput;
    if (!isEmptyString(criteria.fabricStyleCode)) {
      this.loadSkuInventoryAllocationList(listRequest);
    } else {
      let errMsg = "";
      if (!this.state.is3PL) {
        errMsg = "FabricStyleCode is Required";
      } else {
        errMsg = "Item Code is Required";
      }
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadSkuInventoryAllocationList = (criteria) => {
    if (SecurityAccessManager.SkuBatchInventoryMaintenanceView_IsAccessible()) {
      InventoryService.getSkuBatchInventoryPageList(
        criteria,
        this.loadSkuInventoryAllocationPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadSkuInventoryAllocationPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let resultList = new Array();
      if (
        !isEmptyArray(
          response.data.skuBatchInventoryPageList.skuBatchInventories
        )
      ) {
        resultList =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
      }
      this.setState({
        inquiryDataList: resultList,
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isShowLookup: false,
        isShowColorLookup: false,
      });

      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error: " + error);
  };
  rollSkuNumberOnClick = (e, val, rowData) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading...",
      });
      let skuBatchInventoryBeanList = new SKUBatchInventoryBean();
      skuBatchInventoryBeanList.fabricStyleCode = rowData.fabricStyleCode;
      skuBatchInventoryBeanList.fabricStyleName = rowData.fabricStyleName;
      skuBatchInventoryBeanList.fabricStyleColorCode =
        rowData.fabricStyleColorCode;
      skuBatchInventoryBeanList.widthCode = rowData.widthCode;
      skuBatchInventoryBeanList.rollSkuNumber = rowData.rollSkuNumber;
      skuBatchInventoryBeanList.skuNumber = rowData.skuNumber;
      skuBatchInventoryBeanList.aisleInfoText = rowData.aisleInfoText;
      skuBatchInventoryBeanList.purchaseOrderNumber =
        rowData.purchaseOrderNumber;
      skuBatchInventoryBeanList.purchaseOrderReceiptNumber =
        rowData.purchaseOrderReceiptNumber;
      skuBatchInventoryBeanList.containerNumber = rowData.containerNumber;
      skuBatchInventoryBeanList.receivedDate = rowData.receivedDate;
      skuBatchInventoryBeanList.rollNumber = rowData.rollNumber;
      skuBatchInventoryBeanList.vendorBatchNumber = rowData.vendorBatchNumber;
      skuBatchInventoryBeanList.vendorSkuNumber = rowData.vendorSkuNumber;
      skuBatchInventoryBeanList.etaDate = rowData.etaDate;
      skuBatchInventoryBeanList.reserveCustomerCode =
        rowData.reserveCustomerCode;
      skuBatchInventoryBeanList.reserveCustomerName =
        rowData.reserveCustomerName;
      skuBatchInventoryBeanList.landedCost = rowData.landedCost;
      skuBatchInventoryBeanList.fobCost = rowData.fobCost;
      skuBatchInventoryBeanList.cost = rowData.cost;
      skuBatchInventoryBeanList.onHandQuantity = rowData.onHandQuantity;
      skuBatchInventoryBeanList.receivedQuantity = rowData.receivedQuantity;
      skuBatchInventoryBeanList.locationCode = rowData.locationCode;
      this.setState({
        skuBatchInventoryBean: skuBatchInventoryBeanList,
        isShowRollSkuPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let tempCriteria = new SKUBatchInventorySearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    this.setState({
      criteria: tempCriteria,
      isShowColorLookup: false,
      colorList: new Array(),
    });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let tempCriteria = new SKUBatchInventorySearchCriteria();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    tempCriteria.fabricStyleColorCode = "";
    this.setState({
      criteria: tempCriteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      colorList: new Array(),
      isShowLookup: true,
      isShowClearCriteriaButton: true,
      isShowResetButton: false,
      isDisabledFields: false,
      // isViewMode: false,
    });
    this.hideAlertCallBack();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: new Array() });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewFabricStyleModule = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowRollSkuPopup: isShowPopup,
      isShowAlert: isShowPopup,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  UpdateLines = (e) => {
    if (e.detail == 1) {
      let criteria = this.state.skuBatchInventoryBean;
      criteria.companyCode = this.companyCode;
      if (
        SecurityAccessManager.SkuBatchInventoryMaintenanceEdit_IsAccessible()
      ) {
        InventoryService.updateExistingSkuBatchInventory(
          criteria,
          this.loadUpdateSkuInventoryAllocationPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    }
  };
  loadUpdateSkuInventoryAllocationPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      if (!isEmptyArray(response.data.skuBatchInventoryBean)) {
        this.showInfoMessage(response.data);
        this.setState({
          isShowRollSkuPopup: false,
        });
        this.loadPage();
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let skuBatchInventoryBeanList = this.state.skuBatchInventoryBean;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          isShowExitButton={this.state.isShowExitButton}
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          onModuleExit={this.moduleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
        />
        {this.state.isInquiryDatasFound && (
          <div className="div_default">
            <Table id="fabrics_tables">
              <thead>
                <tr>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "rollSkuNumber")
                    }
                  >
                    {this.state.is3PL ? "Inventory#" : "RollSKU#"}
                    {this.state.order === "desc" &&
                    this.state.sortField === "rollSkuNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "fabricStyleCode")
                    }
                  >
                    {this.state.is3PL ? "Item#" : "FabricStyle#"}{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "fabricStyleCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "fabricStyleColorCode")
                    }
                  >
                    Color{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "fabricStyleColorCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "widthCode")}>
                    Width{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "widthCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th onClick={(e) => this.handleSortingChange(e, "skuNumber")}>
                    Sku#{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "skuNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "containerNumber")
                    }
                  >
                    Container#{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "containerNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "purchaseOrderNumber")
                    }
                  >
                    PO#{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "purchaseOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "purchaseOrderReceiptNumber")
                    }
                  >
                    Receipt#{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "purchaseOrderReceiptNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "aisleInfoText")
                    }
                  >
                    BinLoc#{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "aisleInfoText" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "locationCode")}
                  >
                    Location{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "locationCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "vendorBatchNumber")
                    }
                  >
                    VendorLot#{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "vendorBatchNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) => this.handleSortingChange(e, "rollNumber")}
                  >
                    VendorRoll#{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "rollNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "vendorSkuNumber")
                    }
                  >
                    Vendor Sku{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "vendorSkuNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "businessDivision")
                    }
                  >
                    Division{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "businessDivision" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "reserveCustomerCode")
                    }
                  >
                    Cust#{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "reserveCustomerCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "reserveCustomerName")
                    }
                  >
                    Name{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "reserveCustomerName" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingChange(e, "onHandQuantity")
                    }
                  >
                    OnHandQty{" "}
                    {this.state.order === "desc" &&
                    this.state.sortField === "onHandQuantity" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </tr>
              </thead>
              {inquiryDataList != null && (
                <tbody>
                  {inquiryDataList.map((inquiryInfo, index) => (
                    <tr key={index}>
                      <td className="text-right">
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.rollSkuNumberOnClick(
                              e,
                              inquiryInfo.rollSkuNumber,
                              inquiryInfo
                            )
                          }
                        >
                          {inquiryInfo.rollSkuNumber}
                        </Button>
                      </td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewFabricStyleModule(
                              e,
                              inquiryInfo.fabricStyleCode
                            )
                          }
                        >
                          {inquiryInfo.fabricStyleCode}
                        </Button>
                      </td>
                      <td>{inquiryInfo.fabricStyleColorCode}</td>
                      <td>{inquiryInfo.widthCode}</td>
                      <td className="text-right">{inquiryInfo.skuNumber}</td>
                      <td>{inquiryInfo.containerNumber}</td>
                      <td>{inquiryInfo.purchaseOrderNumber}</td>
                      <td>{inquiryInfo.purchaseOrderReceiptNumber}</td>
                      <td>{inquiryInfo.aisleInfoText}</td>
                      <td>{inquiryInfo.locationCode}</td>
                      <td>{inquiryInfo.vendorBatchNumber}</td>
                      <td>{inquiryInfo.rollNumber}</td>
                      <td>{inquiryInfo.vendorSkuNumber}</td>
                      <td>{inquiryInfo.businessDivision}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewCustomerModule(
                              e,
                              inquiryInfo.reserveCustomerCode
                            )
                          }
                        >
                          {inquiryInfo.reserveCustomerCode}
                        </Button>
                      </td>
                      <td>{inquiryInfo.reserveCustomerName}</td>
                      <td className="text-right">
                        {inquiryInfo.onHandQuantity}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
            {inquiryDataList.length != 0 ? null : (
              <div className="no_Data">{"No Data"}</div>
            )}
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowRollSkuPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Sku Batch Entry"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.UpdateLines(e)}
              >
                Update
              </Button>
            </div>
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  {" "}
                  {this.state.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricStyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    placeholder="fabricStyleCode"
                    value={skuBatchInventoryBeanList.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    placeholder="fabricStyleName"
                    value={skuBatchInventoryBeanList.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Color</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    placeholder="fabricStyleColorCode"
                    value={skuBatchInventoryBeanList.fabricStyleColorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Width</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="widthCode"
                    placeholder="widthCode"
                    value={skuBatchInventoryBeanList.widthCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>
                    {this.state.is3PL ? "Inventory#" : "RollSKU#"}
                  </FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="rollSkuNumber"
                    placeholder={this.state.is3PL ? "Inventory#" : "RollSKU#"}
                    value={skuBatchInventoryBeanList.rollSkuNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Sku#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="skuNumber"
                    placeholder="skuNumber"
                    value={skuBatchInventoryBeanList.skuNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>BinLoc#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="aisleInfoText"
                    placeholder="aisleInfoText"
                    value={skuBatchInventoryBeanList.aisleInfoText}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Loc#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="locationCode"
                    placeholder="locationCode"
                    value={skuBatchInventoryBeanList.locationCode}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>PO#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="purchaseOrderNumber"
                    placeholder="purchaseOrderNumber"
                    value={skuBatchInventoryBeanList.purchaseOrderNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Receipt#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="purchaseOrderReceiptNumber"
                    placeholder="purchaseOrderReceiptNumber"
                    value={skuBatchInventoryBeanList.purchaseOrderReceiptNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Container#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="containerNumber"
                    placeholder="containerNumber"
                    value={skuBatchInventoryBeanList.containerNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>OnHandQty</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="onHandQuantity"
                    placeholder="onHandQuantity"
                    value={skuBatchInventoryBeanList.onHandQuantity}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>ReceivedQty</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="receivedQuantity"
                    placeholder="receivedQuantity"
                    value={skuBatchInventoryBeanList.receivedQuantity}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>Shade</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="shade"
                    placeholder="shade"
                    value={skuBatchInventoryBeanList.shade}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  {" "}
                  <FormLabel>Sku Details</FormLabel>
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Vendor Roll#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="rollNumber"
                    placeholder="rollNumber"
                    value={skuBatchInventoryBeanList.rollNumber}
                    onChange={this.onRollChange}
                  />
                </Col>
                <Col sm="1">
                  {" "}
                  <FormLabel>VendorBatch#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="vendorBatchNumber"
                    placeholder="vendorBatchNumber"
                    value={skuBatchInventoryBeanList.vendorBatchNumber}
                    onChange={this.onRollChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  {" "}
                  <FormLabel>Customer</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="reserveCustomerCode"
                    placeholder="reserveCustomerCode"
                    value={skuBatchInventoryBeanList.reserveCustomerCode}
                    lookupRequired={true}
                    onChange={this.customerOnChange}
                    lookupHandler={this.state.customerLookupHandler}
                    showCriteriaDialog={true}
                    enterKeyEventHandler={this.customerEnterKeyEventHandler}
                    autoCompleteListData={
                      this.state.customerPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteCustomerList
                    }
                    showAutoCompleteList={
                      this.state.showAutoCompleteCustomerList
                    }
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="reserveCustomerName"
                    placeholder="reserveCustomerName"
                    value={skuBatchInventoryBeanList.reserveCustomerName}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>
          }
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const onChange = (e) => props.onChange(e);
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const customerCodeEnterKeyEventHandler = (e) =>
    props.customerCodeEnterKeyEventHandler(e);
  const displayAutoCompleteCustomerList = (list) =>
    props.displayAutoCompleteCustomerList(list);
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };

  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  let criteria = props.criteria;
  let customerCodeRef = React.createRef();
  let fabricCodeRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {props.is3PL ? (
            <FormLabel>Item</FormLabel>
          ) : (
            <FormLabel>Fabric</FormLabel>
          )}
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            onChange={fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleName"
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onFabricColourCodeChange}
            name="colorCode"
            placeholder="color"
            value={criteria.colorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Division</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onChange}
            name="businessDivision"
            value={criteria.businessDivision}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          {" "}
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="reserveCustomerCode"
            onChange={customerCodeOnChange}
            value={criteria.reserveCustomerCode}
            lookupRequired={props.isShowLookup}
            lookupHandler={props.customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteCustomerList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisabledFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            name="reserveCustomerName"
            value={criteria.reserveCustomerName}
            disabled={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function RollInventoryMaintenanceModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <SkuInventoryAllocation {...props} name="" /> <br />
    </div>
  );
}
export default RollInventoryMaintenanceModule;
